<template>
    <app-layout>
        <Head>
            <title>Warenkorb</title>
        </Head>

        <template v-slot:overline>
            <translate>jetzt Bestellen</translate>
        </template>

        <template v-slot:headline>
            <translate>Ihr Warenkorb</translate>
        </template>

        <template v-slot:stepper>
            <stepper>
                <step icon="list-basket-checkmark" class-names="active">
                    <translate>Prüfen</translate>
                </step>
                <step icon="delivery-shipment-packages-setting">
                    <translate>Adresse und Zahlungsart</translate>
                </step>
                <step icon="credit-card-security-protection">
                    <translate>Bezahlen</translate>
                </step>
            </stepper>
        </template>

        <div class="checkout">
            <div class="row">
                <div class="col col-8">
                    <card>
                        <card-content>
                            <table class="table table--stripped">
                                <thead>
                                <tr>
                                    <th style="width: 200px; "></th>
                                    <th>
                                        <translate>PF-Nr</translate>
                                    </th>
                                    <th>
                                        <translate>Projekttitle</translate>
                                    </th>
                                    <th class="text-right">
                                        <translate>Stück</translate>
                                    </th>
                                    <th class="text-right">
                                        <translate>Lieferzeit <span>ab Bestellung</span></translate>
                                    </th>
                                    <th class="text-right">
                                        <translate>Lieferdatum <span>Bestellung heute</span></translate>
                                    </th>
                                    <th class="text-right">
                                        <translate>Nettopreis</translate>
                                    </th>
                                    <th class="text-right"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="offer in offers" :key="offer">
                                    <td>
                                        <sketch-preview :sketch-file="offer.ask_for_quote?.client_sketch_file"
                                                        :download="false"/>
                                    </td>
                                    <td>{{ offer.ask_for_quote.pfnumber }}</td>
                                    <td>{{ offer.ask_for_quote.project_name }}
                                        <br><small class="text-medium">{{ offer.ask_for_quote.internal_article_number }}
                                            {{ offer.ask_for_quote.internal_ask_number }}</small>
                                    </td>
                                    <td class="text-right">{{ offer.amount }}</td>
                                    <td class="text-right">{{ offer.delivery_days_client }} <translate>Tage</translate></td>
                                    <td class="text-right">{{ offer.delivery_date }}</td>
                                    <td class="text-right">{{ this.$currency(offer.net_price) }}</td>
                                    <td class="text-right">
                                        <form-link-button :href="offer.route" class="btn--dense" icon="document-edit"/>
                                        <form-link :href="offer.remove_offer" class="btn--dense" icon="trash-delete-bin-2"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </card-content>
                    </card>
                </div>
                <div class="col col-4">
                    <card minify="true">
                        <card-header>
                            <card-overline>
                                <translate>Kasse</translate>
                            </card-overline>
                        </card-header>
                        <card-content>
                            <div class="checkout--sidebar  checkout--total">
                                <translate>Summe Netto</translate>
                                <span class="number">{{ this.$currency(total.net_price) }}</span>
                                <translate>19% USt.</translate>
                                <span class="number">{{ this.$currency(total.ust) }}</span>
                                <strong>
                                    <translate>Gesamtsumme brutto</translate>
                                    <br>
                                    <small class="text-medium">
                                        <translate>inkl. Versandkosten</translate>
                                    </small>
                                </strong>
                                <strong class="number">
                                    {{ this.$currency(total.offer_price) }}
                                </strong>
                                <form-actions align="right">
                                    <form-link-button :href="checkoutDelivery" color="secondary"
                                                      icon="button-arrow-right-circle"><translate>weiter</translate>
                                    </form-link-button>
                                </form-actions>
                            </div>
                        </card-content>
                    </card>
                </div>

            </div>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Stepper from '@partfactory/Shared/Stepper/Stepper';
import Step from '@partfactory/Shared/Stepper/Step';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FormActions from '@partfactory/Shared/Form/FormActions';
import SketchPreview from '@partfactory/Shared/Elements/SketchPreview';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import FormLink from '@partfactory/Shared/Form/FormLink';

export default {
    name: 'Cart',
    components: {
        FormLink,
        FormLinkButton,
        SketchPreview,
        FormActions, CardHeader, CardOverline, CardContent, Card, Step, Stepper, AppLayout
    },
    props: {
        'cart': Object,
    },
    computed: {
        total() {
            let total = {
                net_price: 0,
                ust: 0,
                offer_price: 0,
            };
            if (this.cart) {
                this.cart.forEach(clientOrder => {
                    total.net_price += Number(clientOrder.net_price);
                    total.ust += Number(clientOrder.ust);
                    total.offer_price += Number(clientOrder.offer_price);
                });
            }
            return total;
        },
        offers() {
            let offer = Array;
            if (this.cart) {
                return Object.keys(this.cart).map(key => {

                    offer[key] = this.cart[key];

                    offer[key].ust = offer[key].offer_price - offer[key].net_price;
                    offer[key].ust = (Math.round(offer[key].ust * 100) / 100).toFixed(2);


                    let delivery_date = '';
                    if (this.$moment().isBusinessDay() && !this.$moment().isHoliday()) {
                        delivery_date = this.$moment().add(offer[key].delivery_days_producer, 'days');
                    } else {
                        delivery_date = this.$moment().nextBusinessDay().add(offer[key].delivery_days_producer, 'days');
                    }
                    if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                        delivery_date = delivery_date.nextBusinessDay();
                    }

                    delivery_date = delivery_date.add((offer[key].delivery_days_client - offer[key].delivery_days_producer), 'days');

                    if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                        delivery_date = delivery_date.nextBusinessDay();
                    }

                    offer[key].delivery_date = delivery_date.format('DD.MM.YYYY');


                    offer[key].route = this.$$route('component', {'askForQuote': offer[key].ask_for_quote.id});

                    offer[key].remove_offer = this.$$route('checkout.remove-offer', {'clientOffer': offer[key].id});

                    return offer[key];
                });
            } else {
                return '';
            }

        },
        checkoutDelivery() {
            return this.$$route('checkout.delivery');
        },
    },
};
</script>
